/**
 * Licença do Otto da pessoa logada (conta de plano por licença).
 *
 * Em conta por licença só quem o admin licenciou usa o Otto; as demais pessoas veem o aviso "peça ao administrador". O
 * servidor decide (`ottoLicense` no payload de features, e a API recusa com 403 `OTTO_LICENSE_REQUIRED`); a web só mostra.
 *
 * Falha segura: payload sem o campo vale "licença não exigida", então a tela nunca esconde o produto de quem o tem por um
 * erro de leitura (a API continua sendo a barreira de verdade).
 */

export const OTTO_LICENSE_REQUIRED_CODE = 'OTTO_LICENSE_REQUIRED';
export const OTTO_LICENSE_LIMIT_EXCEEDED_CODE = 'OTTO_LICENSE_LIMIT_EXCEEDED';

/** Conta de plano por conta (a plataforma) sem plano Otto, ou leitura que falhou: nada a exigir. */
export const NO_LICENSE_REQUIRED = Object.freeze({ required: false, assigned: true, overLimit: false, viaPlan: false, plan: null });

/**
 * `overLimit`: a pessoa TEM licença, mas o plano da conta diminuiu (ou o teto veio depois) e ela ficou acima do número de
 * licenças do plano. Continua sem acesso, mas o aviso é outro: não adianta pedir uma licença, é preciso retirar outra ou
 * subir de plano.
 *
 * `viaPlan` e `plan`: em conta da PLATAFORMA a pessoa tem o plano Otto dela (Gratuito, Pro ou Avançado, dado na tela de Usuários).
 * Esse plano libera o vídeo sem o addon da conta e sem a permissão do perfil: a tela não pode pedir nenhum dos dois.
 *
 * @param {unknown} payload `ottoLicense` do payload de `/api/plans/account/features`
 * @returns {{ required: boolean, assigned: boolean, overLimit: boolean, viaPlan: boolean, plan: { tier: string | null, name: string } | null }}
 */
export function parseOttoLicense(payload) {
    if (!payload || typeof payload !== 'object') return NO_LICENSE_REQUIRED;
    const plan = payload.plan && typeof payload.plan === 'object' && typeof payload.plan.name === 'string'
        ? { tier: typeof payload.plan.tier === 'string' ? payload.plan.tier : null, name: payload.plan.name }
        : null;
    return {
        required: payload.required === true,
        assigned: payload.assigned !== false,
        overLimit: payload.overLimit === true,
        viaPlan: payload.viaPlan === true,
        plan,
    };
}

/** A pessoa precisa de uma licença que ainda não tem? (a tela do Otto mostra o aviso em vez das chamadas) */
export const isMissingOttoLicense = (license) => license?.required === true && license?.assigned === false;
